import { Book, Code2, TestTubeDiagonal, Webhook } from "lucide-react";

import { Button } from "@krea/shared/design-system/Button";

import { InnerPageNavigation } from "@/features/page-layouts/inner-page-navigation";
import settings from "@/settings";

import { ApiIntegrationSection } from "../components/api-integration-section";
import { TestYourAPISection } from "../components/test-your-api-section";
import { WebhookConfigSection } from "../components/webhook-config-section";
import { useGetCurrentLenderCompanyQuery } from "../hooks/use-get-lender-company.query";

export const ApiPage = () => {
  const {
    data: lenderCompany,
    isError,
    refetch,
  } = useGetCurrentLenderCompanyQuery();
  const isProduction = import.meta.env.MODE === "production";

  if (isError || !lenderCompany) {
    return (
      <main className="mx-auto max-w-6xl px-4 py-6 sm:p-8">
        <div className="rounded-xl border p-6">
          <p className="font-semibold">Couldn’t load company settings</p>
          <p className="mt-1 text-sm">Please try again.</p>
          <button
            className="mt-4 rounded-lg px-4 py-2 text-white"
            onClick={() => refetch()}
          >
            Retry
          </button>
        </div>
      </main>
    );
  }

  return (
    <div className="relative mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <aside className="md:col-span-3 md:self-start">
          <InnerPageNavigation
            offsetTopPx={16}
            scrollContainerSelector="#main-content-scroll-container"
            items={[
              {
                id: "api-integration",
                label: "API Integration",
                icon: Code2,
              },
              {
                id: "webhook-config",
                label: "Webhook Configuration",
                icon: Webhook,
              },
              ...(!isProduction
                ? [
                    {
                      id: "test-your-api",
                      label: "Test Your API",
                      icon: TestTubeDiagonal,
                    },
                  ]
                : []),
            ]}
          />
        </aside>

        <div className="space-y-10 md:col-span-9">
          <div className="rounded-lg border border-primary-300 bg-primary-150 p-4">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary">
                  <Book className="h-5 w-5 text-white" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-primary">
                    API Documentation
                  </div>
                  <div className="text-xs text-primary-400">
                    Learn how to integrate with our API
                  </div>
                </div>
              </div>

              <Button size="sm">
                <a
                  href={settings.keaLenderIntegrationApiDocsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white"
                >
                  View Docs
                </a>
              </Button>
            </div>
          </div>
          <section id="api-integration" className="scroll-mt-24">
            <ApiIntegrationSection />
          </section>

          <section id="webhook-config" className="scroll-mt-24">
            <WebhookConfigSection />
          </section>

          {!isProduction && (
            <section id="test-your-api" className="scroll-mt-24">
              <TestYourAPISection />
            </section>
          )}
        </div>
      </div>
    </div>
  );
};
